export { Modal } from "./Modal";
export { ModalBody, ModalHeader, ModalFooter } from "@nextui-org/react";
